namespace SP {
    export interface UpdatedShipmentLine {
        shipmentId: string;
        shipmentLineId: string;
        orderLineId: string;
        warehouseReasonId: string;
        warehouseActionId: string;
        quantity: number;
        note: string;
    }
}